import React from "react";
import { Menu, MenuList } from "@chakra-ui/react";
import { Email, Print, VetspireExport } from "./components";

interface ExportProps {
  isVetspireCase: boolean;
  menuButton: React.ReactNode;
  caseId: number;
  onClose?(): void;
}

const Export: React.FC<ExportProps> = props => {
  const { isVetspireCase, menuButton, caseId, onClose } = props;
  const [opened, setOpened] = React.useState(false);

  const handleClose = () => {
    setOpened(false);
    if (typeof onClose === "function") {
      onClose();
    }
  };

  return (
    <Menu
      isOpen={opened}
      onOpen={() => setOpened(true)}
      placement="left-start"
      closeOnSelect={false}
      onClose={() => setOpened(false)}
      autoSelect={false}
    >
      {menuButton}

      <MenuList>
        <VetspireExport
          handleClose={handleClose}
          caseId={caseId}
          isVetspireCase={isVetspireCase}
        />

        <Email handleClose={handleClose} caseId={caseId} />

        <Print handleClose={handleClose} caseId={caseId} />
      </MenuList>
    </Menu>
  );
};

export default Export;
